import React, { useState } from 'react';
import useBrands from '../hooks/useBrands';
import BrandTable from '../components/brand/BrandTable';
import BrandSearchFilters from '../components/brand/BrandSearchFilters';
import CreateBrandModal from '../components/brand/CreateBrandModal';
import EditBrandModal from '../components/brand/EditBrandModal';
import Snackbar from '../components/Snackbar';

const BrandManagement = () => {
  const { brands, loading, error, pagination, fetchBrands, createBrand, updateBrand, snackbar, closeSnackbar } = useBrands();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [filters, setFilters] = useState({
    keyword: '',
    sourceSite: ''
  });

  const handlePageChange = (page) => {
    // 필터를 API 형식으로 변환
    const apiFilters = {
      keyword: filters.keyword || undefined,
      source_site: filters.sourceSite || undefined
    };
    fetchBrands(page, pagination.size, apiFilters);
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSearch = () => {
    // 필터를 API 형식으로 변환
    const apiFilters = {
      keyword: filters.keyword || undefined,
      source_site: filters.sourceSite || undefined
    };
    fetchBrands(1, pagination.size, apiFilters);
  };

  const handleCreateClick = () => {
    setIsCreateModalOpen(true);
  };

  const handleCloseCreateModal = () => {
    setIsCreateModalOpen(false);
  };

  const handleCreate = async (formData) => {
    const result = await createBrand(formData);
    if (result.success) {
      handleCloseCreateModal();
      // 필터를 유지하면서 현재 페이지 다시 불러오기
      const apiFilters = {
        keyword: filters.keyword || undefined,
        source_site: filters.sourceSite || undefined
      };
      fetchBrands(pagination.page, pagination.size, apiFilters);
    }
  };

  const handleEditClick = (brand) => {
    setSelectedBrand(brand);
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedBrand(null);
  };

  const handleSave = async (formData) => {
    if (!selectedBrand) return;
    
    const result = await updateBrand(selectedBrand.id, formData);
    if (result.success) {
      handleCloseEditModal();
      // 필터를 유지하면서 현재 페이지 다시 불러오기
      const apiFilters = {
        keyword: filters.keyword || undefined,
        source_site: filters.sourceSite || undefined
      };
      fetchBrands(pagination.page, pagination.size, apiFilters);
    }
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-lg">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">브랜드 관리</h2>
        <button
          onClick={handleCreateClick}
          className="px-4 py-2 bg-slate-600 text-white rounded-lg hover:bg-slate-700 transition-colors text-sm"
        >
          브랜드 생성
        </button>
      </div>
      
      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700">
          {error}
        </div>
      )}

      <BrandSearchFilters
        filters={filters}
        onFilterChange={handleFilterChange}
        onSearch={handleSearch}
      />

      <BrandTable 
        brands={brands} 
        loading={loading}
        pagination={pagination}
        onPageChange={handlePageChange}
        onEdit={handleEditClick}
      />

      <CreateBrandModal
        isOpen={isCreateModalOpen}
        onClose={handleCloseCreateModal}
        onSave={handleCreate}
      />

      <EditBrandModal
        isOpen={isEditModalOpen}
        brand={selectedBrand}
        onClose={handleCloseEditModal}
        onSave={handleSave}
      />

      <Snackbar
        open={snackbar.open}
        message={snackbar.message}
        type={snackbar.type}
        onClose={closeSnackbar}
      />
    </div>
  );
};

export default BrandManagement;

